import { ChangeDetectionStrategy, Component, computed, effect, inject } from '@angular/core';
import { CartItemComponentStore } from 'cart-data';
import { ItemComponentBase } from 'products-ui';
import { WireCutCartItemSummaryViewComponent } from './views';

@Component({
  selector: 'ideal-wire-cut-cart-item-summary',
  imports: [WireCutCartItemSummaryViewComponent],
  standalone: true,
  templateUrl: './wire-cut-cart-item-summary.component.html',
  styleUrl: './wire-cut-cart-item-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CartItemComponentStore],
})
export class WireCutCartItemSummaryComponent extends ItemComponentBase {
  private readonly _store = inject(CartItemComponentStore);

  protected readonly isLoading = computed(() => this._store.cartItemLoading() || this._store.cartItemLoading());
  protected readonly isPriceOnRequest = computed(() => this._store.cartItemPricing().pricingModel.isCallForPricing);
  protected readonly isUpdating = computed(() => this._store.cartItemUpdating());
  protected readonly cartItemQuantity = computed(() => this._store.cartItemQuantity());

  constructor() {
    super();
    effect(() => {
      this._store.selectByItemId(this.itemId());
    });
  }

  protected onQuantityChange(quantity: number) {
    this._store.updateItemQuantity(quantity);
  }
}
